import { DocumentTextIcon, InformationCircleIcon } from "@heroicons/react/24/outline";

import { LearnerFileType } from "@api/graphql/types-and-hooks";
import { FilesCollapsible } from "@pages/ClinicalReportDetails/Components/AssessmentFiles/FilesCollapsible";
import { useClinicalReportDetailsData } from "@providers/ClinicalReportDetailsProvider";

interface PreviousAssessmentReportCollapsibleProps {
  handleFileClicked?: (learnerFile: LearnerFileType) => void;
}

export const PreviousAssessmentReportCollapsible: React.FC<PreviousAssessmentReportCollapsibleProps> = ({
  handleFileClicked,
}) => {
  const { previousAssessmentReports, downloadReportFileById } = useClinicalReportDetailsData();

  const reportsForDisplay = previousAssessmentReports.filter((report) => report.mimeType === "application/pdf");

  const headerText = "Previous Assessment Report";
  const headerIcon = <DocumentTextIcon className="text-limestone-700 h-4 w-4" />;
  const topContent = (
    <div className="flex items-start bg-green-100 text-green-800 p-2 mt-2 rounded-sm">
      <div>
        <InformationCircleIcon className="h-4 w-4" />
      </div>
      <div className="ml-2 text-xs">You can select text from these reports to insert into your current document</div>
    </div>
  );

  return (
    <div id="previous-report" className="w-full max-w-full">
      <FilesCollapsible
        files={reportsForDisplay}
        topContent={topContent}
        headerIcon={headerIcon}
        headerText={headerText}
        downloadFileCallback={downloadReportFileById}
        fileClickedCallback={handleFileClicked}
      />
    </div>
  );
};
